import React from 'react'
import { UserIcon } from '@heroicons/react/20/solid'
import { t } from 'i18next'
import { AGE_GROUPS } from '../../pages/constants'
import stSeat from '../../assets/images/icons/st_seat.svg'
import vipSeat from '../../assets/images/icons/vip_seat.svg'

export function PassengerCard({ 
    person, 
    isSelected, 
    luggageCount = 0, 
    onToggle, 
    onLuggageChange,
    disabled = false
}) {
    return (
        <div className={`bg-gray-50 rounded-lg p-4 border border-gray-200 ${disabled ? 'opacity-90' : ''}`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => onToggle(person.passenger_id)}
                        disabled={disabled}
                        className={`h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded ${disabled ? 'cursor-not-allowed' : ''}`}
                    />
                    <div className="flex items-center gap-2">
                        <UserIcon className="w-5 h-5 text-primary" />
                        <div>
                            <div className="flex items-center gap-2">
                                <h6 className="text-sm font-semibold text-gray-900">
                                    {person.passenger.given_name} {person.passenger.family_name}
                                </h6>
                                {person.check_in && (
                                    <span className={`text-xs px-2 py-0.5 rounded ${
                                        person.check_in.status?.code === 'CHK' 
                                            ? 'bg-green-100 text-green-800' 
                                            : person.check_in.status?.code === 'CRT'
                                            ? 'bg-yellow-100 text-yellow-800'
                                            : 'bg-gray-100 text-gray-800'
                                    }`}>
                                        {person.check_in.status?.description?.en || person.check_in.status?.code || t('Checked In')}
                                    </span>
                                )}
                            </div>
                            <p className="text-xs text-gray-600">
                                {AGE_GROUPS[person.passenger.age_group_code] || person.passenger.age_group_code}
                            </p>
                        </div>
                    </div>
                </div>
                {person.seat_info && (
                    <div className="flex items-center gap-2">
                        <img
                            src={person.seat_info.seat_type_code === 'VIP' ? vipSeat : stSeat}
                            className="w-5 h-5"
                            alt={person.seat_info.seat_type_code}
                        />
                        <span className="text-sm font-medium text-gray-700">
                            {person.seat_info.seat_no}
                        </span>
                    </div>
                )}
            </div>

            {/* Luggage and Special Assistance for selected passengers */}
            {isSelected && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {t('Luggage Count')}
                            </label>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => onLuggageChange(person.passenger_id, luggageCount - 1)}
                                    disabled={disabled}
                                    className={`w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-300'}`}
                                >
                                    -
                                </button>
                                <span className="w-12 text-center font-semibold">
                                    {luggageCount}
                                </span>
                                <button
                                    onClick={() => onLuggageChange(person.passenger_id, luggageCount + 1)}
                                    disabled={disabled}
                                    className={`w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-300'}`}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
